const AUTH_PATHS = ['/login', '/signup', '/auth']

export function safeReturnPath(value, fallback = '/account') {
  if (
    typeof value !== 'string' ||
    !value.startsWith('/') ||
    value.startsWith('//')
  ) {
    return fallback
  }

  if (/\\|[\u0000-\u001f\u007f]/.test(value)) return fallback

  let decoded
  try {
    decoded = decodeURIComponent(value)
  } catch {
    return fallback
  }

  if (/\\|[\u0000-\u001f\u007f]/.test(decoded)) return fallback

  const url = new URL(value, 'https://mono.fm')
  if (
    AUTH_PATHS.some(
      path => url.pathname === path || url.pathname.startsWith(`${path}/`),
    )
  ) {
    return fallback
  }

  return `${url.pathname}${url.search}${url.hash}`
}
